import { render, staticRenderFns } from "./DeleteEducationModal.vue?vue&type=template&id=18652d28"
import script from "./DeleteEducationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteEducationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports